<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<mat-card class="block">
  <h2>Schedule windows</h2>
  <p class="meta" *ngIf="schedulePhaseHelp">{{ schedulePhaseHelp }}</p>
  <form [formGroup]="form" (ngSubmit)="save()">
    <div formArrayName="windows" class="list">
      <div class="row" *ngFor="let group of windows.controls; let i = index" [formGroupName]="i">
        <div class="form-grid" style="flex:1">
          <mat-form-field appearance="outline"><mat-label>Key</mat-label><input matInput formControlName="key" /></mat-form-field>
          <mat-form-field appearance="outline"><mat-label>Label</mat-label><input matInput formControlName="label" /></mat-form-field>

          <div class="key-date-field">
            <mat-form-field appearance="outline">
              <mat-label>Starts</mat-label>
              <input
                matInput
                [matDatepicker]="startsPicker"
                [value]="windowGroup(i).controls['startsAt'].value"
                (dateChange)="onWindowDatePicked(i, 'startsAt', $event.value)"
              />
              <mat-datepicker-toggle matIconSuffix [for]="startsPicker"></mat-datepicker-toggle>
              <mat-datepicker #startsPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="time-field">
              <mat-label>Time</mat-label>
              <input
                matInput
                type="time"
                [value]="windowTime(i, 'startsAt')"
                (change)="onWindowTimeChanged(i, 'startsAt', $any($event.target).value)"
              />
            </mat-form-field>
          </div>

          <div class="key-date-field">
            <mat-form-field appearance="outline">
              <mat-label>Ends</mat-label>
              <input
                matInput
                [matDatepicker]="endsPicker"
                [value]="windowGroup(i).controls['endsAt'].value"
                (dateChange)="onWindowDatePicked(i, 'endsAt', $event.value)"
              />
              <mat-datepicker-toggle matIconSuffix [for]="endsPicker"></mat-datepicker-toggle>
              <mat-datepicker #endsPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="time-field">
              <mat-label>Time</mat-label>
              <input
                matInput
                type="time"
                [value]="windowTime(i, 'endsAt')"
                (change)="onWindowTimeChanged(i, 'endsAt', $any($event.target).value)"
              />
            </mat-form-field>
          </div>
        </div>
        <button mat-button type="button" (click)="removeWindow(i)" [disabled]="windows.length <= 1">Remove</button>
      </div>
    </div>
    <div class="actions" style="margin-top:1rem">
      <button mat-stroked-button type="button" (click)="addWindow()">Add window</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || busy">Save schedule</button>
    </div>
  </form>
</mat-card>